import { createTheme } from '@one-thd/sui-atomic-components';

const RWBSecondaryTwo = createTheme({
  palette: {
    mode: 'light',
    background: {
      primary: 'brand'
    }
  }
});

RWBSecondaryTwo.palette['--sui-palette-background-primary'] = '164 199 205';

export { RWBSecondaryTwo };
